import moment from 'moment'
import {Base, model, endpoint, hasMany, property} from '@scoutgg/ftw/source/lib/model'
import rules from '@scoutgg/scoring-rules'

const normalSubType = {
  alpine: ['superg', 'slalom', 'giant_slalom'],
  cc_ski: ['classic', 'skiathlon'],
}
const matchTypes = {
  cycling: ['normal', 'sprint', 'climb', 'checkpoint', 'team'],
  horses: ['normal', 'v75'],
  golf: ['normal', 'one_round'],
  cc_ski: ['normal', 'sprint', 'qualification', 'relay', 'mass_start_men', 'mass_start_women', 'team_sprint', 'tour'],
  cricket: ['normal', 'odi', 'test'],
  alpine: ['normal', 'downhill', 'team', 'combined', 'individual_duel'],
  biathlon: ['mixed_relay', 'sprint', 'pursuit', 'individual', 'single_mixed', 'relay', 'mass_start'],
  mma: ['normal', 'preliminary'],
  tennis: ['normal', 'set3'],
  formula_one: ['normal', 'qualifier', 'sprint'],
  futsal: ['normal', 'tournament'],
  dota2: ['normal', 'bo2', 'bo3', 'bo5'],
  rocket_runout: ['normal', 'one_round'],
  eurovision: ['normal', 'qualifier'],
}

console.log('league') // League doesn't register without this statement
@model('League')
@endpoint('leagues', {root: '/api'})
@hasMany('seasons')
export class League extends Base {
  @property(moment) updatedAt;

  get rules() {
    return rules(this.sport)
  }

  get isDuel() {
    return !this.rules?.hasTag('nonDuel')
  }

  get isTimeTrial() {
    return this.rules?.hasTag('timeTrial')
  }

  get isRacing() {
    return this.rules?.hasTag('racing')
  }

  get isCrossCountry() {
    return this.rules?.hasTag('crossCountry')
  }

  get matchTypes() {
    return matchTypes[this.sport]
  }

  get normalSubTypes() {
    return normalSubType[this.sport]
  }
}
